import { useQuery } from 'react-query';
import { AllActivitiesService } from '@api/AllActivitiesService';
import { onDefaultError } from '../helpers/commonHelpers';
// My All Tasks Master
const useListAllActivities = (
  [
    currentPage,
    selectedProject,
    selectedEmployee,
    selectedSprint,
    selectedInactiveUser
  ],
  onSuccess,
  onError = onDefaultError
) => {
  return useQuery(
    [
      'all-activities-list',
      currentPage,
      selectedProject,
      selectedEmployee,
      selectedSprint,
      selectedInactiveUser
    ],
     () =>
      AllActivitiesService.listTask({
        currentPage,
        selectedProject,
        selectedEmployee,
        selectedSprint,
        selectedInactiveUser
      }),
    {
      onSuccess,
      keepPreviousData: true,
      onError,
    }
  );
};

// Employee List
const useGetAllActivityEmployeeList = (projectIds, onSuccess, onError = onDefaultError) => {
  return useQuery(['all-activities-user-list', projectIds], () =>  AllActivitiesService.getEmployees(projectIds), {
    onSuccess,
    onError
  });
};
// Project List
const useGetAllActivityProjects = (onSuccess, onError = onDefaultError) => {
    return useQuery('all-activities-project-list', () => AllActivitiesService.projectList(), {
        onSuccess,
        keepPreviousData: true,
        onError,
    });
};
// Sprint List
const useGetAllActivitySprints = (params, onSuccess, onError = onDefaultError) => {
    const isEnabled = params?.project_id ? true : false;
    return useQuery(['all-activities-sprint-list', [params]], () => AllActivitiesService.sprintList(params), {
        onSuccess,
        keepPreviousData: true,
        onError,
        enabled: isEnabled
    });
};
export{
  //All Activities Master
  useListAllActivities,
  useGetAllActivityEmployeeList,
  useGetAllActivityProjects,
  useGetAllActivitySprints
};